import { render } from "./GeoFencingEvents.vue?vue&type=template&id=bb1caae2"
import script from "./GeoFencingEvents.vue?vue&type=script&lang=js"
export * from "./GeoFencingEvents.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__